@if (loaded) {
  <div class="playbook-box pageMaxWidth">
    <section id="mainPlaybookSection" class="card page-card">
      <app-template-editor [returnUrl]="returnUrl" (updateTemplateManifest)="refreshPageTemplateManifest()" [pageTemplate]="pageTemplate" [containers]="playbook.containers[0]"  [playbookId]="playbook?.id"></app-template-editor>
    </section>
    @for (cont of playbook?.containers; track cont) {
      @if (resourceOn) {
        <app-resource-lists [pageTemplateId]="pageTemplateId" [resContainer]="cont" [languageId]="1" (click)="clearSelectedEditor(true)">
        </app-resource-lists>
      }
    }
    @for (cont of playbook?.containers; track cont) {
      <app-nav-holder [container]="cont" [pageTemplateId]="pageTemplateId">
      </app-nav-holder>
    }
  </div>
}